import createLucideIcon from '../createLucideIcon';

const Pause = createLucideIcon('Pause', [
  ['rect', { width: '4', height: '16', x: '6', y: '4', key: 'iffhe4' }],
  ['rect', { width: '4', height: '16', x: '14', y: '4', key: 'sjin7j' }],
]);

export default Pause;
